import { Component, EventEmitter, Inject, Input, OnInit, Output, ViewChild } from "@angular/core";
import { Observable } from "rxjs";
import { ReviewDetail } from "../../../core/model/v2/review/review-detail";
import { ReviewSummary } from "src/app/core/model/v2/review/review-summary";
import { ReviewService } from "../../../core/services/v2/review-service";
import { WindowLoaderService } from "../window-loader/window-loader.service";
import { Review } from "../../../core/model/v2/review/review";
import { Practitioner } from "../../../core/model/v2/practitioner/practitioner";
import { PracticeService } from "../../../core/services/v2/practice.service";
import { debug } from "console";
import { ChangeDetectorRef } from "@angular/core";
import { Education } from "../models/education.model";
import { Awards } from "../models/awards.model";
import { MatDialog } from "@angular/material";
import { RequestAppointmentDialogComponent } from "../request-appointment-dialog/request-appointment-dialog.component";
import { ActivatedRoute } from "@angular/router";
import { PatientService } from "../../../core/services/v2/patient.service";
import { PatientFavoriteRequest } from "../../../core/models/patient/patientFavoriteRequest";
import Swal, { SweetAlertIcon, SweetAlertResult } from "sweetalert2";
import { Patient } from "../../../core/models/patient/patient";
import { UserService } from "../../../core/services/v2/user.service";
import { UtilsService } from "../../../core/services/v2/utils.service";
import { Socialmedia } from "../../../core/model/v2/practitioner/socialmedia";

@Component({
  selector: 'app-physician-info',
  templateUrl: './physician-info.component.html',
  styleUrls: ['./physician-info.component.scss']
})
export class PhysicianInfoComponent implements OnInit {
  @Input() practitionerId;
  @Input() canEditPractitioner: boolean;
  professionalData: any;
  @Output() datarefreshProfile = new EventEmitter<any>();
  DetailProfessional: Practitioner;
  profileData = {};

  reviewSummary: ReviewSummary;
  reviewDetail: ReviewDetail;
  //reviewSummary: ReviewSummary;
  npiNumber: string;
  formattedNumber: string;
  isEditPhysicianInfo: boolean = false;
  profilevalue: any;
  practitionerEdu: Education[];
  practitionerAwards: Awards[];
  socialMediaLinks: Socialmedia[];
  eduObj: Practitioner;
  awardObj: Awards;
  patientId: number;
  fromPractitionerId: number;
  favoriteObj: any;
  //patientProfile: Patient;
  loggedPractitionerId: number;

  constructor(
    private reviewService: ReviewService,
    private patientService: PatientService,
    private loaderService: WindowLoaderService,
    private practiceService: PracticeService,
    private changeDetectorRef: ChangeDetectorRef,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private userService: UserService,
    private utils: UtilsService,
  ) {
  }

  ngOnInit() {
    this.getParams();
    this.getUserDetails();
  }

  ngOnChanges() {
    if (this.practitionerId && this.practitionerId != NaN && this.practitionerId > 0) {
      this.getDetailsById(this.practitionerId);
    }
  }
  getUserDetails() {

    this.loaderService.show();

    this.userService.getUserDetails().subscribe(
      (userData) => {

        this.loggedPractitionerId = userData.practitionerId;
        if (
          this.loggedPractitionerId == this.practitionerId ||
          userData.managedPractitionerIds.indexOf(this.practitionerId) >= 0
        ) {
          this.canEditPractitioner = true;
        } else {
          this.canEditPractitioner = false;
        }
        this.changeDetectorRef.detectChanges();
      },
      (error) => {
        console.error(error);
        this.loaderService.hide();
      },
      () => {
        this.loaderService.hide();
      }
    );
  }

  getReviewDetail(npi: string) {
    this.reviewService.getReviewDetail(npi).subscribe(
      (details) => {
        this.reviewDetail = details;
        console.log("GetReviewDetail Result: ", this.reviewDetail);
      },
      (error) => { console.error(error); });
  }

  getReviewSummary(npi: string) {
    this.reviewService.getReviewSummary(npi).subscribe(
      (details) => {
        this.reviewSummary = details;
        this.changeDetectorRef.detectChanges();
        console.log("GetReviewSummary Result: ", this.reviewSummary);
      },
      (error) => { console.error(error); });
  }
  categorySelection(catval: string) {
    if (catval == "EditPhysicianInfo") {
      this.isEditPhysicianInfo = true;
    };

  }

  getDetailsById(practitionerId: number) {
    let that = this;

    that.loaderService.show();
    that.loaderService.blockWithLoader(that.practiceService.getPractitionerDetails(practitionerId)).subscribe(
      (practitionerData) => {
        that.professionalData = practitionerData;
        that.profileData = practitionerData; //For showing practitioner data instead of hospital data.

        that.eduObj = practitionerData;
        that.profilevalue = practitionerData;
        that.bindFormFields();
        console.log("PRACTITONER DATA INFO: ", that.profileData);
        that.changeDetectorRef.detectChanges();

      },
      (error) => {
        console.error(error);
        that.loaderService.hide();
      },
      () => {
        that.loaderService.hide();
        that.datarefreshProfile.emit(that.profileData);
      }
    );

  }


  bindSocialMedia() {
    let smObj = JSON.parse(this.eduObj.education);
    this.socialMediaLinks = smObj;
  }

  getDetailsByNpiId(npiId: string) {
    var that = this;

    that.loaderService.show();
    that.practiceService.getPractitionerDetailsByNpi(npiId).subscribe(
      (practitionerData) => {
        that.professionalData = practitionerData;
        that.profileData = practitionerData; //For showing practitioner data instead of hospital data.
        that.eduObj = practitionerData;
        that.profilevalue = practitionerData;
        that.bindFormFields();
        console.log("PRACTITONER DATA INFO: ", that.profileData);
        that.changeDetectorRef.detectChanges();

      },
      (error) => {
        console.error(error);
        that.loaderService.hide();
      },
      () => {
        that.loaderService.hide();
        that.datarefreshProfile.emit(that.profileData);
      }
    );

  }

  getPatientFavoritesById(id) {
    this.loaderService.blockWithLoader(this.patientService.getPatientFavoritesById(id)).subscribe(
      (details) => {
        const practitioner = details.practitioners.filter(x => x.id == this.practitionerId || x.npi == this.npiNumber);
        if (practitioner && practitioner.length > 0) {
          this.favoriteObj = practitioner[0];
        }
        else {
          this.favoriteObj = null;
        }
        this.changeDetectorRef.detectChanges();
      },
      (error) => { console.error(error); }
    );
  }
  getPractitionerFavoritesById(id) {
    this.loaderService.blockWithLoader(this.practiceService.getPractitionerFavorites(id, '')).subscribe(
      (details) => {
        const practitioner = details.practitioners.filter(x => x.practitionerId == this.practitionerId || x.practitionerNPI == this.npiNumber);
        if (practitioner && practitioner.length > 0) {
          this.favoriteObj = practitioner[0];
        }
        else {
          this.favoriteObj = null;
        }
        this.changeDetectorRef.detectChanges();
      },
      (error) => { console.error(error); }
    );
  }

  //getPatientDetailsById(id) {
  //  this.loaderService.blockWithLoader(this.patientService.getPatientDetailsById(id)).subscribe(
  //    (details) => {
  //      this.patientProfile = null;
  //      this.patientProfile = details;
  //    },
  //    (error) => { console.error(error); this.loaderService.hide(); }
  //  );
  //}

  stopLoader() {

    this.profileData = {};
    this.loaderService.hide();
    //window.location.reload();
    this.getDetailsById(this.practitionerId);
    this.isEditPhysicianInfo = false;
    this.changeDetectorRef.detectChanges();
  }

  bindFormFields() {
    if (this.professionalData && this.professionalData != 'undefined') {
      this.profileData = this.professionalData;
      this.DetailProfessional = this.professionalData;
      this.eduObj = this.professionalData;
      this.npiNumber = this.professionalData.npi;
      this.getReviewDetail(this.npiNumber);
      this.getReviewSummary(this.npiNumber);
      let arrEducationDetailsControlsGroup = [];
      let jsonObj = JSON.parse(this.eduObj.education); // string to "any" object first
      let awardsJsonObj = JSON.parse(this.eduObj.awards); // string to "any" object first
      this.practitionerAwards = awardsJsonObj as Awards[];
      this.practitionerAwards=this.practitionerAwards.filter(x => x.awardname != null);
      if (this.practitionerAwards.length == 1 && this.practitionerAwards.find(x => x.awardname.trim().length == 0)) {
        this.practitionerAwards = [];
      }
      let smJsonObj = JSON.parse(this.eduObj.socialMedia); // string to "any" object first
      this.practitionerEdu = jsonObj as Education[];
      if (this.practitionerEdu.length == 1 && this.practitionerEdu.find(x => x.university.trim().length == 0)) {
        this.practitionerEdu = [];
      }


      this.socialMediaLinks = smJsonObj as Socialmedia[];
    }
  }

  getParams() {
    this.route.params.subscribe(
      (params) => {
        this.npiNumber = params["npi"];
        if (this.practitionerId && this.practitionerId != NaN && this.practitionerId > 0) {
          this.getDetailsById(this.practitionerId);
        }
        else if (this.npiNumber) {
          this.getDetailsByNpiId(this.npiNumber);
        }

        if (params["patientId"]) {
          this.patientId = +params["patientId"];
        }
        if (params["fromPractitionerId"]) {
          this.fromPractitionerId = +params["fromPractitionerId"];
        }
        if (!this.practitionerId) {
          this.practitionerId = +params["id"];
        }
        if (this.patientId) {
          this.getPatientFavoritesById(this.patientId);
        }
        if (this.fromPractitionerId) {
          this.getPractitionerFavoritesById(this.fromPractitionerId);
        }
      },
      (error) => {
        console.error(error);
      }
    );
  }

  addOrRemovePatientFavorite(action: string) {
    if (action == 'ADD') {
      if (this.patientId) {
        let data: PatientFavoriteRequest = {
          userId: 0,
          patientId: this.patientId,
          favoriteNPIId: this.professionalData.npi,
          npiType: this.professionalData.npitype ? this.professionalData.npitype : 'PRACTITIONER',
          action: action
        }
        this.loaderService.blockWithLoader(this.patientService.setOrRemovePatientFavorites(data)).subscribe(
          (details) => {
            if (details.isSuccess) {
              this.getPatientFavoritesById(this.patientId);
              Swal.fire(
                'Done!',
                'Your favorite list is updated.',
                'success'
              )
            }
            else if (details.message) {
              this.utils.showMessageSnackBar(details.message, true);
            }
          },
          (error) => { console.error(error); }
        );
      }
      if (this.fromPractitionerId) {
        const physicianFav = {
          practitionerId: this.fromPractitionerId,
          favoriteId: this.practitionerId ? this.practitionerId : null,
          favoriteNpi: this.professionalData.npi,
          favoritesTypeId: 1
        };
        this.loaderService.blockWithLoader(this.practiceService.addPractitionerFavorites(physicianFav)).subscribe(
          (details) => {
            if (details.isSuccess) {
              this.getPractitionerFavoritesById(this.fromPractitionerId);
              Swal.fire(
                'Done!',
                'Your favorite list is updated.',
                'success'
              )
            }
            else if (details.message) {
              this.utils.showMessageSnackBar(details.message, true);
            }
          },
          (error) => { console.error(error); }
        );
      }
    }
    if (action == 'REMOVE') {
      Swal.fire({
        title: `Remove Favorite`,
        text: `Are you sure want to remove Dr. ${this.professionalData.fullName} from your favorites?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes'
      }).then((result) => {
        if (result.isConfirmed) {
          if (this.patientId) {
            let data: PatientFavoriteRequest = {
              userId: 0,
              patientId: this.patientId,
              favoriteNPIId: this.professionalData.npi,
              npiType: this.professionalData.npitype ? this.professionalData.npitype : 'PRACTITIONER',
              action: action
            }
            this.loaderService.blockWithLoader(this.patientService.setOrRemovePatientFavorites(data)).subscribe(
              (details) => {
                if (details.isSuccess) {
                  this.getPatientFavoritesById(this.patientId);
                  Swal.fire(
                    'Done!',
                    'Your favorite list is updated.',
                    'success'
                  )
                }
                else if (details.message) {
                  this.utils.showMessageSnackBar(details.message, true);
                }
              },
              (error) => { console.error(error); }
            );
          }
          if (this.fromPractitionerId) {
            this.loaderService.blockWithLoader(this.practiceService.deletePractitionerFavorites(this.favoriteObj.id)).subscribe(
              (details) => {
                if (details.response.isSuccess) {
                  this.getPractitionerFavoritesById(this.fromPractitionerId);
                  Swal.fire(
                    'Done!',
                    'Your favorite list is updated.',
                    'success'
                  )
                }
                else if (details.response.message) {
                  this.utils.showMessageSnackBar(details.response.message, true);
                }
              },
              (error) => { console.error(error); }
            );
          }
        }
      })

    }
  }

  requestAppointment() {
    if (!this.professionalData.isInNetwork) {
      Swal.fire({ title: "Request Appointment", text: "Please call on  469-353-6852 to book you appointment." });
    }
    else if (this.professionalData) {
      let dialogRef = this.dialog.open(RequestAppointmentDialogComponent, {
        width: '840px',
        disableClose: true,
        data: {
          professionalData: this.professionalData,
          patientId: this.patientId
        }
      })
      dialogRef.afterClosed().subscribe(result => {
        if (result && result.success === true) {
          document.getElementById("openSuccessModal").click();
        }
      });
    }
  }
}
